import "../../../styles/input.scss";

import Icon, {iconTypes} from "./Icon.jsx";
import React, {Component} from "react";

import PropTypes from "prop-types";

export default class Accordion extends Component {
    constructor(props){
        super(props);

        this.state = {
            expanded: false
        };

        this.toggleExpand = this.toggleExpand.bind(this);
    }

    toggleExpand(e) {
        e.stopPropagation();

        this.setState({
            expanded: !this.state.expanded,
        });
    }

    render() {
        const {
            children,
            label
        } = this.props;
        return(
            <div className="accordion-wrapper">
                <div className="accordion-header" onClick={this.toggleExpand}>
                    <div className="accordion-label">
                        {label}
                    </div>
                    <div className="accordion-label-info">
                        {label}
                    </div>
                    {this.state.expanded ? (
                        <Icon type={iconTypes.up} className="accordion-icon" style={{zIndex: 0}}/>
                    ) : (
                        <Icon type={iconTypes.down} className="accordion-icon" style={{zIndex: 0}}/>
                    )}
                </div>
                {this.state.expanded && (
                    children
                )}
            </div>
        );
    }
}

Accordion.propTypes = {
    children: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    labelInfo: PropTypes.string
};

Accordion.defaultProps = {
    labelInfo: ""
};